import { ITabelaPrecoDTO } from './../dto/tabela-preco-dto';
import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { ClientesApi } from '../api/clientes.api';
import { ICliente } from '../models/cliente';
import { IClienteDTO } from '../dto/cliente-dto';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DadosInadimplenciaDTO } from '../dto/dados-inadimplencia-dto';

@Injectable()
export class ClientesService extends ServiceBase<ICliente, IClienteDTO> {


    getTabelasDePreco(clienteId: string): Observable<ITabelaPrecoDTO[]> {
        return this.api.doGet(`tabelas-de-precos/${clienteId}`);
    }

    getDadosInadimplencia(CGC: string): Observable<DadosInadimplenciaDTO> {
        return this.api.doGet(`dados-inadimplencia/${CGC}`).pipe(map((res) => {
            return new DadosInadimplenciaDTO(res);
        }));
    }

    constructor(private api: ClientesApi) {
        super(api);
    }
}
